let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iTHC8")).then(() => parcelRequire('1bupc'));